var exports = {
  "content": "x9997bc76--740ad7--content",
  "icon": "x9997bc76--740ad7--icon",
  "apple-btn": "x9997bc76--740ad7--apple-btn",
  "google-btn": "x9997bc76--740ad7--google-btn",
  "text": "x9997bc76--740ad7--text",
};

module.exports = exports;
